export default "__VITE_ASSET__d65d89c2__"